/*
Single source of truth for what may be persisted from Vuex state into
localStorage.

KAN-39: the `auth` slice (access + refresh JWTs, decoded claims,
expiresAt) MUST NOT leak into localStorage — tokens live in
sessionStorage per acceptance criteria #7 ("Login persists both tokens
in sessionStorage") and #13 ("Closing the tab ends the session").

Used by:
  * vuex-persistedstate reducer (src/main.js)
  * saveStore() (src/main.js) — legacy imperative persister

Any new cross-tab-unsafe slice goes in STRIPPED_KEYS.
------------------------------------------------------------------------ */

export const STRIPPED_KEYS = ['auth']

export function stripSensitiveState (state) {
  const out = {}
  if (!state) {
    return out
  }
  for (const k in state) {
    if (!Object.prototype.hasOwnProperty.call(state, k)) {
      continue
    }
    if (STRIPPED_KEYS.indexOf(k) !== -1) {
      continue
    }
    out[k] = state[k]
  }
  return out
}

export default {
  STRIPPED_KEYS: STRIPPED_KEYS,
  stripSensitiveState: stripSensitiveState
}



// WEBPACK FOOTER //
// ./src/lib/persistState.js